import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import { TikTok } from '../../../shared/assets/icons';

export const socials = [
	{
		id: 1,
		label: 'Instagram',
		icon: Instagram,
		href: 'https://www.instagram.com/finpath_am',
	},
	{
		id: 2,
		label: 'Facebook',
		icon: Facebook,
		href: 'https://www.facebook.com/share/1KY8MyQXWe/',
	},
	{
		id: 3,
		label: 'LinkedIn',
		icon: Linkedin,
		href: 'https://www.linkedin.com/company/finpath-am/',
	},
	{
		id: 4,
		label: 'YouTube',
		icon: Youtube,
		href: 'https://www.youtube.com/channel/UC1jXpQ7jkNTr23XVNKKNMvw',
	},
	{
		id: 5,
		label: 'TikTok',
		icon: TikTok,
		href: 'https://www.tiktok.com/@finpath4',
	},
];
